export const getFormworkFile_api = {
	url: 'getFormworkFile',
	method: 'get',
	title: '模板文件列表'
}



// WEBPACK FOOTER //
// ./src/views/maijia/maijiaDatamoint/desc.js